import { useState } from "react";
import { Alert, Button, Col, Collapse, Row } from "react-bootstrap";

export function Banner() {
    const [bannerOpen, setBannerOpen] = useState(true);


    return (
      <Alert variant="pp-alert-notice">
            <Row>
                <Col xs={11} md={11} lg={11} xl={11}>&nbsp;</Col>
                <Col xs={1} md={1} lg={1} xl={1}>
                    <Button className="pp-notice-close" variant="close" onClick={() => setBannerOpen(!bannerOpen)} aria-controls="pp-notice" aria-expanded={bannerOpen}>{bannerOpen ? "Hide" : "Show"}</Button>
                </Col>
            </Row>
            <Collapse in={bannerOpen}>
                <div className="pp-notice">
                    <p><i>*** Updated 06/16/2025 **</i></p>
                    <Row>
                        <Col>
                            <p><strong>Important Changes to ABCC and Self-Assessment CME – Please read carefully before proceeding further</strong></p>
                            <p>
                                ABPN is pleased to announce that starting in June 2025, the required number of article exams in the <a className="system-notification-link" href="https://abpn.org/wp-content/uploads/2025/06/ABCC-article-limit-FAQs.pdf">Article-Based 
                                Continuing Certification (ABCC) Pathway is now set at 20 every three years</a> for each certification. 
                                This approach makes it easier to keep track of article exam progress for those with two or 
                                more certifications. Your Portal will now show your article exam progress separately for each of your certifications.  Also beginning now for diplomates 
                                in the Continuing Certification (CC) Program, the Self-Assessment CME requirement is <a className="system-notification-link" href="https://abpn.org/wp-content/uploads/2025/06/SA-CME-FAQs.pdf">reduced 
                                from 24 SA-CME credits to 16 SA-CME credits per 3-year CC block.</a>
                            </p>
                            <p>
                                ABCC is an ongoing assessment pathway. Diplomates must successfully complete article exams every 3 years to remain in the ABCC pathway. If a diplomate 
                                successfully completes the ABCC article exams for 3 consecutive 3-year blocks (i.e., 9 years), there are no article exams required in the 10th year.
                            </p>
                            <p>
                                Diplomates choosing the ABCC Pathway will begin their first 3-year ABCC block the year after their initial certification or most recent recertification in that field.
                            </p>
                            <p>
                                Diplomates who do not successfully complete the article exams in their first 3-year ABCC block will be able to 'catch up' in their second 3-year block. 
                                However, further 'catch-up' is not possible: diplomates who do not successfully complete the article exams after that second 3-year block will be required to
                                take the Continuing Certification examination in year 10, provided they have remained in good standing with all other CC Program requirements.
                            </p>
                            <p>
                                Please refer to <a className="system-notification-link" href="https://abpn.org/continuing-certification/">Continuing Certification</a> Activity
                                Requirements and <a className="system-notification-link" href="https://abpn.org/continuing-certification/article-based-continuing-certification-pathway-abcc/">ABCC FAQs</a> for more information and details.
                            </p>
                        </Col>
                    </Row>
                </div>
            </Collapse>
        </Alert>
        
    )
}